import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from './index';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Custom hooks for common operations
export const useAuthRedux = () => {
  return useAppSelector((state) => state.auth);
};

// Legacy export - prefer useAuthRedux to avoid confusion with Context hook
export const useAuth = useAuthRedux;

export const useUser = () => {
  return useAppSelector((state) => state.user);
};

export const useTheme = () => {
  return useAppSelector((state) => state.theme);
};
